import React from 'react';
import { Box, Typography, Checkbox, Chip, Stack } from '@mui/material';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { format } from 'date-fns';


export interface StoryListItemProps {
    story: {
        id: number;
        title?: string;
        type?: string;
        tags?: string[];
        created?: Date;
    };
    checked: boolean;
    onToggle: (id: number, checked: boolean) => void;
}

export const StoryListItem: React.FC<StoryListItemProps> = ({
  story,
  checked,
  onToggle,
}) => (
  <Stack
    alignItems="flex-start"
    gap={2}
    p={2}
    border={1}
    borderColor="divider"
    borderRadius="12px"
    sx={{
      transition: 'background 0.2s',
      '&:hover': { backgroundColor: (theme) => theme.palette.action.hover },
    }}
  >
    <Checkbox
      checked={checked}
      onChange={(e) => onToggle(story.id, e.target.checked)}
      sx={{ mt: 0.5 }}
    />
    <Box flex={1} minWidth={0}>
      <Box display="flex" alignItems="center" justifyContent="space-between" mb={0.5}>
        <Typography variant="subtitle2" fontWeight={500} noWrap>
          {story.title}
        </Typography>
        <Chip
          label={story.type}
          size="small"
          color="secondary"
          sx={{ flexShrink: 0, fontSize: 12 }}
        />
      </Box>
      {(story?.tags && story?.tags?.length > 0) && (
        <Box display="flex" alignItems="center" gap={1} flexWrap="wrap" mb={0.5}>
          <LocalOfferIcon sx={{ fontSize: 16, color: 'text.secondary', flexShrink: 0 }}/>
          <Box display="flex" flexWrap="wrap" gap={0.5}>
            {[...(story.tags || [])].slice(0, 3).map((tag) => (
              <Chip
                key={tag}
                label={tag}
                size="small"
                variant="outlined"
                sx={{
                  fontSize: 11,
                  background: (theme) => theme.palette.action.selected,
                  color: 'text.secondary',
                }}
              />
            ))}
            {[...(story.tags || [])].length > 3 && (
              <Typography variant="caption" color="text.secondary">
                                +{
                  ([ ...(story.tags || [])].length - 3)
                }
              </Typography>
            )}
          </Box>
        </Box>
      )}
      <Box display="flex" alignItems="center" gap={0.5} color="text.secondary">
        <CalendarTodayIcon sx={{ fontSize: 16 }}/>
        <Typography variant="caption">
          Created {story.created ? format(new Date(story.created), 'MMM dd, yyyy'): ''}
        </Typography>
      </Box>
    </Box>
  </Stack>
);
